// Angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

// Third party modules
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';
//import { ToastyModule } from 'ng2-toasty';
// import { NgxMaskModule } from 'ngx-mask';
import { DataTablesModule } from 'angular-datatables';

import { SharedPropertiesRoutingModule } from './shared-properties-routing.module';
import { SharedPipesModule } from '../../../shared/shared-pipes/shared-pipes.module';
import { DuplicatePropertyListComponent } from './duplicate-property-list/duplicate-property-list.component';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        //ToastyModule.forRoot(),
        ModalModule.forRoot(),
        // NgxMaskModule.forRoot(),
        TabsModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ReactiveFormsModule,
        DataTablesModule,
        SharedPropertiesRoutingModule, SharedPipesModule
    ],
    declarations: [DuplicatePropertyListComponent],
    exports: [DuplicatePropertyListComponent],
})
export class SharedPropertiesModule { }
